// ========== IMPORTS ==========
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import TermsAndConditions from './components/pages/TermsAndCondition';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import RefundPolicy from './components/pages/RefundPolicy';
import ScrollToTop from './components/ScrollToTop';

import PaymentSuccess from './components/registrationComp/PaymentSuccess';
import PaymentFailure from './components/registrationComp/PaymentFailure';

import LandingPage from './components/sections/LandingPage';
import LandingPath from './components/sections/LandingPath';
function App() {


  return (
    <>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={1000} />
      <div className="app">
        <Routes>
          <Route path="/" element={<LandingPath />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />

        </Routes>
      </div>
    </>
  );
}

export default App;
